import { checkUsername } from 'api/config/auth';
import { socialLinkTypeIdsOrderForProfile, socialLinkTypes } from 'ui/common/social-links';

export const fieldNames = {
  username: 'username',
  name: 'name',
  bio: 'bio',
  img: 'img',
  position: 'position',
  yearsOfExperience: 'yearsOfExperience',
  employmentStatus: 'employmentStatus',
  socialLinks: 'socialLinks',
};

export const asyncFields = {
  [fieldNames.username]: {
    uniquenessAsync: {
      api: value => checkUsername({ username: value }),
      message: 'already taken',
    },
  },
};

export default {
  [fieldNames.username]: {
    username: true,
    length: {
      minimum: 3,
      maximum: 30,
    },
  },
  [fieldNames.name]: {
    presence: true,
  },
  [fieldNames.bio]: {
    length: {
      maximum: 320,
    },
  },
  [fieldNames.position]: {
    presence: true,
    length: {
      maximum: 100,
    },
  },
  [fieldNames.yearsOfExperience]: {
    presence: true,
    numericality: true,
  },
  [fieldNames.employmentStatus]: {
    presence: true,
  },
  [fieldNames.img]: {
    file: {
      size: {
        minimum: Number(process.env.REACT_APP_AVATAR_MIN_SIZE_IN_BYTES) || 100,
        maximum: Number(process.env.REACT_APP_AVATAR_MAX_SIZE_IN_BYTES) || 500 * 1024,
      },
    },
  },
};

export const socialLinkFieldNames = {
  type: 'type',
  url: 'url',
};

export function socialLinkModel(typeId = null) {
  const socialLinkType = socialLinkTypes[typeId];

  return {
    type: {
      presence: false,
      length: {
        maximum: 64,
      },
      inclusion: socialLinkTypeIdsOrderForProfile,
    },
    url: {
      presence: true,
      url: {
        defaultScheme: 'https',
        domains: (socialLinkType && socialLinkType.domains) || [],
        domainMessage: `is not a valid ${socialLinkType.messages.name.defaultMessage} url`,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/ui/graphql/UpdateSocialLinks/model.js